import { render, staticRenderFns } from "./ClientDeliveryMap.vue?vue&type=template&id=1bb5fde4"
import script from "./ClientDeliveryMap.vue?vue&type=script&lang=js"
export * from "./ClientDeliveryMap.vue?vue&type=script&lang=js"
import style0 from "./ClientDeliveryMap.vue?vue&type=style&index=0&id=1bb5fde4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports